import { FC } from 'react';
import { DeviceToken } from '../types/User';
import { Button, ButtonSizes, ButtonStyles, EntityChip } from '@silverfort/sf-components';
import AdditionalInfo from './AdditionalInfo';
import { TOKEN_TYPE_TO_DETAILS } from '../consts';

const MAX_TOKENS_TO_DISPLAY_ON_POPOVER = 4;

interface Props {
    tokens: DeviceToken[];
    onViewTokenClick: (tokenId: DeviceToken['id']) => void;
    onViewAllTokensClick?: () => void;
}

const TokensAdditionalInfo: FC<Props> = ({ tokens, onViewTokenClick, onViewAllTokensClick }) => {
    const tokensToRender = Math.min(tokens.length, MAX_TOKENS_TO_DISPLAY_ON_POPOVER);

    const handleViewClick = (tokenId: string) => {
        onViewTokenClick(tokenId);
    };

    return (
        <AdditionalInfo
            title={`Tokens (${tokens.length})`}
            Content={
                <div className="w-[336px] flex flex-row flex-wrap">
                    {tokens.slice(0, tokensToRender).map((token) => {
                        const { label, icon, iconClassName } = TOKEN_TYPE_TO_DETAILS[token.type];

                        return (
                            <div key={token.id} className="px-2 py-1 flex-1 flex gap-2 w-[164px]">
                                <EntityChip
                                    className="leading-[14.32px] w-[164px]"
                                    text={label}
                                    icon={icon}
                                    iconClassName={iconClassName}
                                    onClick={() => handleViewClick(token.id)}
                                />
                            </div>
                        );
                    })}
                </div>
            }
            Footer={
                <div className="flex justify-center">
                    <Button
                        onClick={onViewAllTokensClick}
                        text="View all"
                        buttonStyle={ButtonStyles.GhostSolid}
                        buttonSize={ButtonSizes.Small}
                    />
                </div>
            }
        />
    );
};

export default TokensAdditionalInfo;
